module.exports = __webpack_public_path__ + "static/media/cherry_and_lemon.fc3de9c5.png";